var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgTickCheckMark = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_9004773_tick_check_mark_accept_icon_2_",
    "data-name": "9004773_tick_check_mark_accept_icon (2)",
    d: "M21,1A20,20,0,1,0,41,21,20,20,0,0,0,21,1ZM31.376,16.831,18.649,29.558a1.818,1.818,0,0,1-2.571,0L10.624,24.1a1.818,1.818,0,1,1,2.571-2.571L17.364,25.7,28.805,14.26a1.818,1.818,0,1,1,2.571,2.571Z",
    transform: "translate(-1 -1)",
    fill: "#1bc675"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTickCheckMark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick_check_mark.f19b70cc.svg";
export { ForwardRef as ReactComponent };